import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Drawer, Grid2, Tab } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { DrawerHeader } from "../../_components/drawer/header.drawer";
import { FormTemplateManage } from "./formTemplate-manage";

export function FormTemplateManageDrawer(params: {
    emitOnSave: (id?: number) => void,
    emitOnClose: () => void,
}) {

    const { formTemplateId } = useParams<{ formTemplateId: string }>();
    const [tab, setTab] = useState('1');
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        if (isOpen == false)
            setIsOpen(true);
    }, []);

    let navigate = useNavigate();

    const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        navigate("");
        setTab(newValue.toString());
    };

    return (
        <Drawer
            anchor={"right"}
            variant="persistent"
            open={isOpen}
            sx={{
                '& .MuiDrawer-paper.MuiDrawer-paperAnchorRight': {
                    width: '650px !important'
                }
            }}
            ModalProps={{
                keepMounted: true
            }}>

            <DrawerHeader name={(!!formTemplateId) ? "Update Form Template" : "Create Form Template"} onClose={params.emitOnClose} />

            <TabContext value={tab}>    
                <Grid2 size={{ xs: 12 }} sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={handleTabChange}>
                        <Tab label="Template" value="1" />
                        {(!!formTemplateId) && <Tab label="Sections" value="2" />}

                    </TabList>
                </Grid2>

                <Grid2 size={{ xs: 12 }}>
                    <TabPanel value="1" sx={{ p: 0.5, m: 0.5 }}>
                        <FormTemplateManage emitOnSave={params.emitOnSave} emitOnClose={params.emitOnClose} />
                    </TabPanel>
                    <TabPanel value="2" sx={{ p: 0.5, m: 0.5 }}>
                        <Outlet />
                    </TabPanel>
                </Grid2>

            </TabContext>
        </Drawer>
    );
}